jQuery(function($){
	var swiper = new Swiper(".shop-by-category-carousel", {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: true,
		grabCursor: true,
		pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
		breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          778: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1350: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
        },
    });

    $(window).bind('scroll', function() {
		var scrollTop = $(window).scrollTop();
		var docHeight = $(document).height();
		var winHeight = $(window).height();
		var scrollPercent = (scrollTop) / (docHeight - winHeight);
		var scrollPercentRounded = Math.round(scrollPercent*100);

		if (scrollPercentRounded >= 50) {
			$('.star-section-wrapper').addClass('in-hidden');
		} else {
			$('.star-section-wrapper').removeClass('in-hidden');
		}
	});
	
	const checkReviewsInterval = setInterval(function(){
		if( $('.jdgm-carousel__item-wrapper').length > 0 ) {
			clearInterval(checkReviewsInterval);
			$('.jdgm-carousel__item-wrapper').find('a').attr('rel','nofollow');
		}
	}, 50);
	$(document).ready(function(){
		$('.read_more').on('click', function(e){
			e.preventDefault();
			$('.product-description-short').removeClass('line-clamp');
			$('.read_less').show();
			$('.product-description-read').hide();
		});
		$('.read_less').on('click', function(e){
			e.preventDefault();
			$('.product-description-short').addClass('line-clamp');
			$('.read_less').hide();
			$('.product-description-read').show();
		});
		$('.subtext-read-more-wrapper').on('click', function(e){
			$('.read-moreless-text-wrapper').toggleClass('active');
		});
	});
})